import {Injectable} from "@angular/core";
import {Observable} from "rxjs";

import {ApplicationsPageData} from "./applications-manager-dashboard/applications-datatable/applications-page-data";
import {ApplicationsDashboardList} from "./applications-manager-dashboard/applications-datatable/applications-dashboardList";
import {ApplicationsPage} from "./applications-manager-dashboard/applications-datatable/applications-page";

/**
 * A server used to mock a paged data result from a server
 */
@Injectable()
export class ApplicationsManagerDashboardResultService {
    listData:any;
    loginData;
    rows = {};
    applicationsDashboardData = {};

    constructor(){}

    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    public getResults(page: ApplicationsPage,listData): Observable<ApplicationsPageData<ApplicationsDashboardList>> {
        this.listData = listData;
        return Observable.of(listData).map(data => this.getPageData(page));
    }

    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    private getPageData(page: ApplicationsPage): ApplicationsPageData<ApplicationsDashboardList> {
        let pageData = new ApplicationsPageData<ApplicationsDashboardList>();
        let offset = this.listData.offset;
        let raw = [];
        for(let l in this.listData){
            if(Object.keys(this.listData[l]).length > 0){
                raw[offset+parseInt(l)] = this.listData[l];
            }
        }
        if(this.listData.totalCount){
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        let start = page.pageNumber * page.size;
        let end = Math.min((start + page.size), page.totalElements);
        for (let i = start; i < end; i++) {
            if(raw[i]){
                let jsonObj = raw[i];
                if(jsonObj){
                    let list = new ApplicationsDashboardList(jsonObj['id'], jsonObj['applicationId'], jsonObj['applicationName'], jsonObj['userId_WPASS'],
                        jsonObj['businessUnitId'], jsonObj['businessUnitName'], jsonObj['countryId'], jsonObj['countryName'], jsonObj['approverId'],
                        jsonObj['approverName'], jsonObj['multipleRole'], jsonObj['reason'], jsonObj['status'], jsonObj['statusCode'], jsonObj['updatedAt']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/applicationsManagerDashboardResultService.ts